import React from "react";

const SvgYoutube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 20"
    fill="none"
  >
    <path
      d="M24.4851 3.75186C24.1968 2.58584 23.3525 1.66647 22.2816 1.35254C20.3253 0.769531 12.4999 0.769531 12.4999 0.769531C12.4999 0.769531 4.67461 0.769531 2.71828 1.33012C1.66803 1.64405 0.803127 2.58584 0.514825 3.75186C0 5.8821 0 10.2995 0 10.2995C0 10.2995 0 14.7394 0.514825 16.8472C0.803127 18.0132 1.64744 18.9326 2.71828 19.2465C4.6952 19.8295 12.4999 19.8295 12.4999 19.8295C12.4999 19.8295 20.3253 19.8295 22.2816 19.2689C23.3525 18.955 24.1968 18.0356 24.4851 16.8696C24.9999 14.7394 24.9999 10.322 24.9999 10.322C24.9999 10.322 25.0205 5.8821 24.4851 3.75186Z"
      fill="#FF0000"
    />
    <path
      d="M10.0078 6.21875V14.3809L16.5152 10.2998L10.0078 6.21875Z"
      fill="white"
    />
  </svg>
);

export default SvgYoutube;
